import { useAppSelector } from "@hooks/store"
import { useNewEditTemplateCollectionContext } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/context/NewEditTemplateCollectionContext"
import { useMemo, useState } from "react"

export const useArrearsOption = () => {

    const { currencySymbol } = useAppSelector(state => state.auth)
    const { chargeDetail, buttonsArrearsOptions, setChargeDetail, setHasUnsavedChanges } = useNewEditTemplateCollectionContext()
    const [isOpenModal, setIsOpenModal] = useState(false)

    const handleOpenCloseModal = ({ isOpenModal }) => {
        setIsOpenModal(isOpenModal)
    }

    const handleSwitchArrearsOption = ({ value }) => {        
        setHasUnsavedChanges(true)
        setChargeDetail(prev => ({
            ...prev,
            late_fee: {
                ...prev.late_fee,
                metadata: {
                    ...prev.late_fee.metadata,
                    enabled: value
                }
            }
        }))
    }

    const lateFeeData = useMemo(() =>
        buttonsArrearsOptions.find((item) => item.id === chargeDetail.late_fee.metadata?.charge_late_fee_type_id),
        [buttonsArrearsOptions, chargeDetail.late_fee.metadata?.charge_late_fee_type_id])


    return {
        isOpenModal,
        currencySymbol,
        chargeDetail,
        lateFeeData,
        handleSwitchArrearsOption,
        handleOpenCloseModal
    }
}